import React, { useState } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { Button, Layout, message, Table, Spin, Select, Input, Upload } from "antd";
import { Link } from "react-router-dom";
import { DownloadOutlined, UploadOutlined, DownOutlined, DeleteOutlined } from '@ant-design/icons'
import axios from 'axios';
import './FinalMasterAudit.css'
import Cookies from "js-cookie";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

const { Header, Content } = Layout;

const FinalMasterAudit = () => {
    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");

    const [SNfile, setSNFile] = useState(null)
    const [Activefile, setActiveFile] = useState(null)
    const [SNdata, getSNData] = useState([])
    const [ActivelistData, getActiveData] = useState([])
    const [ComparisionList, getComparisionData] = useState([])
    const [tableLoader, setTableLoader] = useState(false)
    const [fileLoader, setFileLoader] = useState(false)
    const [notes, setNotes] = useState({})
    const [actions, setActions] = useState({});

    const fileProps = (handleFileChange) => ({
        name: 'file',
        accept: '.xls,.xlsx',
        beforeUpload: (file) => {
            const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 'application/vnd.ms-excel';
            if (!isXlsx) {
                message.error('You can only upload XLSX file!');
                return Upload.LIST_IGNORE;
            }
            return false;
        },
        onChange(info) {
            const { status } = info.file;
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
            handleFileChange(info);
        },
        onRemove: () => {
            setSNFile(null)
            setActiveFile(null)
        },
        showUploadList: {
            showRemoveIcon: true,
            removeIcon: <DeleteOutlined style={{ color: "red" }} />,
        },
    });

    const handleSNFileChange = ({ file }) => {
        const fileType = file.type;
        const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        if (!validTypes.includes(fileType)) {
            message.error("Invalid file type. Please upload an Excel file.");
            return;
        }
        else {
            setSNFile(file)
        }
    };

    const handleActiveFileChange = ({ file }) => {
        const fileType = file.type;
        const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        if (!validTypes.includes(fileType)) {
            message.error("Invalid file type. Please upload an Excel file.");
            return;
        }
        else {
            setActiveFile(file)
        }
    };

    const handleFilesUpload = async (props) => {
        if (!SNfile || !Activefile) {
            message.error("Please upload both files")
        }
        else {
            setTableLoader(true)
            const formData = new FormData();
            formData.append('firstFile', SNfile);
            formData.append('secondfile', Activefile);

            axios.post(`${process.env.REACT_APP_BASE_URL}FinalMasterAudit/SNupload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${jwtToken}`,
                }
            })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        const resdata = response.data.payload
                        const res = JSON.parse(resdata)
                        getSNData(res.SNData);
                        getActiveData(res.ActiveListData)
                        getComparisionData(res.ComparisonResults)
                        message.success('Uploaded successfully!');
                        setSNFile(null)
                        setActiveFile(null)
                        setTableLoader(false)
                    }
                    else if (response.data.statusCode === 500) {
                        message.warning(response.data.message)
                        getSNData([])
                        setTableLoader(false)
                    }
                    else {
                        setTableLoader(false)
                        getSNData([])
                        setSNFile(null)
                        setActiveFile(null)
                    }
                })
                .catch((error) => {
                    message.error('Error while uploading file');
                    setTableLoader(false)
                })
        }
    };

    const handleExcelList = () => {
        let snList = SNdata;
        let loopedList = [];
        loopedList.length = 0;
        let len = snList.length;
        let i;
        loopedList.push(['File Number', 'First Name', 'Last Name', 'Working Status', 'End Date', 'Clientname in SN', 'Clientname in Activelist', 'Payrate in SN', 'Payrate in Activelist', 'PayFrequencyCode in SN', 'PayFrequencyCode in Activelist',
            'WorkState in SN', 'WorkState in Activelist', 'HomeState Province', 'TempWorkState Province', 'ExemptStatus in SN', 'ExemptStatus in Activelist', 'DOB in SN', 'DOB in Activelist', 'Remarks', 'Notes', 'Action'])
        for (i = 0; i < len; i++) {
            loopedList.push([
                snList[i].PayrollFileNumber,
                snList[i].FirstName,
                snList[i].LastName,
                snList[i].WorkingStatus,
                snList[i].EndDate,
                snList[i].Client,
                snList[i].Activelist_Client,
                snList[i].PayRate,
                snList[i].Activelist_PayRate,
                snList[i].PaymentFrequency,
                snList[i].Activelist_PaymentFrequency,
                snList[i].WorkState,
                snList[i].Activelist_WorkState,
                snList[i].HomeStateProvince,
                snList[i].TempWorkStateProvince,
                snList[i].ExemptStatus,
                snList[i].Activelist_ExemptStatus,
                snList[i].DOB,
                snList[i].Activelist_DOB,
                snList[i].Remarks,
                notes[snList[i].Id] || '',
                actions[snList[i].Id] || '',
            ]);
        }
        handleOnExport(loopedList);
    };

    const handleOnExport = async (props) => {
        setFileLoader(true)
        try {
            const payData = props;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (let i = 0; i < payData.length; i++) {
                worksheet.addRow(payData[i]);
                if (!payData[i][19] || payData[i][19].trim() === "") {
                    worksheet.getRow(i + 1).fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "00FF00" },
                    };
                } else if (payData[i][19].toLowerCase().includes("mismatch")) {
                    worksheet.getRow(i + 1).fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FF0000" },
                    };
                }
            }
            message.success("Downloaded successfully !!")
            setFileLoader(false)
            return workbook.xlsx.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    FileSaver.saveAs(blob, 'FinalMasterAudit.xlsx');
                });


        }
        catch (err) {
            message.error("Cannot able download, please try again")
            setFileLoader(false)
        }
    };

    const columns = [
        {
            title: 'File Number',
            dataIndex: 'PayrollFileNumber',
            key: 'File Number',
            width: 100,
            height: 50,
            fixed: "left",
        },
        {
            title: 'Client',
            dataIndex: 'Client',
            key: 'Client',
            width: 100,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.Client);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'Pay Rate',
            dataIndex: 'PayRate',
            key: 'Pay Rate',
            width: 80,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.PayRate);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'Pay Frequency Code',
            dataIndex: 'PaymentFrequency',
            key: 'Pay Frequency Code',
            width: 150,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.PaymentFrequency);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'Work State',
            dataIndex: 'WorkState',
            key: 'Work State',
            width: 100,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.WorkState);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'HomeState Province',
            dataIndex: 'HomeStateProvince',
            key: 'HomeState Province',
            width: 200,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.HomeStateProvince);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'TempWorkState Province',
            dataIndex: 'TempWorkStateProvince',
            key: 'TempWorkState Province',
            width: 200,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.TempWorkStateProvince);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'Exempt Status',
            dataIndex: 'ExemptStatus',
            key: 'Exempt Status',
            width: 120,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.ExemptStatus);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'DOB',
            dataIndex: 'DOB',
            key: 'DOB',
            width: 60,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.DOB);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'Remarks',
            dataIndex: 'Remarks',
            key: 'Remarks',
            width: 100,
            height: 50,
        },
        {
            title: 'Notes',
            key: 'Notes',
            dataIndex: 'Id',
            render: (Id) => (
                <Input
                    value={notes[Id] || ''}
                    onChange={(e) => {
                        setNotes({ ...notes, [Id]: e.target.value });
                    }}
                    style={{ width: "auto" }}
                />
            ),
            width: 150,
            fixed: 'right',
        },
        {
            title: 'Action',
            key: 'Action',
            dataIndex: 'Id',
            render: (Id) => (
                <Select
                    value={actions[Id] || ''}
                    style={{ width: 150 }}
                    onChange={(value) => {
                        setActions({ ...actions, [Id]: value });
                    }}
                    allowClear
                >
                    <Option value="Action required">Action required</Option>
                    <Option value="No Action required">No Action required</Option>
                </Select>
            ),
            width: 150,
            fixed: 'right',
            filters: [
                {
                    text: 'All',
                    value: 'All',
                },
                {
                    text: 'Action required',
                    value: 'Action required',
                },
                {
                    text: 'No Action required',
                    value: 'No Action required',
                },
            ],
            onFilter: (value, record) => {
                if (value === 'All') {
                    return true;
                }
                const action = actions[record.Id] || '';
                return action.trim() === value;
            },
            filterIcon: (filtered) => (
                <DownOutlined style={{ color: filtered ? "#002766" : "#002766" }} />
            ),
        },
    ];

    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout className="whole-div">
                    <Header className="timecards-header">
                        <Navbar />
                    </Header>
                    <Content style={{ height: "100%", overflow: "auto" }}>
                        <div className="payrollhrs-allpages-class">
                            <Link to="/payrollhoursaudit"><Button className="payrollhrs-page-button">Payroll Hours Audit</Button></Link>
                            <Button className="payrollhrs-currentpage-button">Final Master Audit</Button>
                            <Link to="/preview"><Button className="payrollhrs-page-button">Preview/Review</Button></Link>
                            <Link to="/payrollchecklist"> <Button className="payrollhrs-page-button">Payroll Checklist</Button></Link>
                            <Link to="/audit"><Button className="payrollhrs-page-button">Selected Crawling</Button></Link>
                            {/* <Link to="/activitylog"><Button className="payrollhrs-page-button">Activity Log</Button></Link> */}
                        </div>
                        <div className="finalaudit-input-div">
                            <div className="file-upload" style={{ height: "39px", width: "15%", borderRadius: "10px", marginRight: "10px" }}>
                                <Upload.Dragger {...fileProps(handleSNFileChange)} style={{ border: "1px solid #002766", borderRadius: 10, borderStyle: "dashed" }}>
                                    <div className='content-garfile'>
                                        <span>Upload SN File</span>
                                        <UploadOutlined style={{ fontSize: 17 }} />
                                    </div>
                                </Upload.Dragger>
                            </div>
                            <div className="file-upload" style={{ height: "39px", width: "15%", borderRadius: "10px" }}>
                                <Upload.Dragger {...fileProps(handleActiveFileChange)} style={{ border: "1px solid #002766", borderRadius: 10, borderStyle: "dashed" }}>
                                    <div className='content-garfile'>
                                        <span>Upload Activelist</span>
                                        <UploadOutlined style={{ fontSize: 17 }} />
                                    </div>
                                </Upload.Dragger>
                            </div>
                            <Button className="download-finalauditbutton" style={{ marginLeft: "3%" }} onClick={handleFilesUpload}>Upload<UploadOutlined /></Button>
                            <Button className="download-finalauditbutton" loading={fileLoader} style={{ marginLeft: "40%" }} onClick={handleExcelList}>Download<DownloadOutlined /></Button>
                        </div>
                        <div className="finalaudit-table-div">
                            {
                                tableLoader ? <Spin tip="Loading...">
                                    <Table className="masteraudit-table"
                                        bordered
                                        scroll={{ x: "max-content", y: 350 }}
                                        columns={columns}
                                        //pagination={{ pageSize, position: ['bottomRight'] }}
                                        dataSource={SNdata.map(item => ({ ...item, key: item.Id }))}
                                    />
                                </Spin> : SNdata ?
                                    <Table className="masteraudit-table"
                                        columns={columns}
                                        bordered
                                        //pagination={{ pageSize, position: ['bottomRight'] }}
                                        dataSource={SNdata.map(item => ({ ...item, key: item.Id }))}
                                        scroll={{ x: "max-content", y: 350 }}
                                    />
                                    : null
                            }
                        </div>
                    </Content>
                </Layout >
            </Layout >
        </>
    )
}
export default FinalMasterAudit;